import { Injectable, Inject } from '@angular/core';
import { Http, Response, ResponseContentType, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { Router } from '@angular/router';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
//import 'rxjs/add/observable/throw';
import { CompanyModel } from '../Models/CompanyModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //"Content-Type": "application/x-www-form-urlencoded"
    //'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class UserPlanFormatingService {

  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.myAppUrl = baseUrl;
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.myAppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  getQuestions(groupid, TokenKey: string, userid: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get<any>(this.myAppUrl + "api/QuestionMaster/GetQuestionMaster/null/" + groupid + "/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }
  saveans(anslist, logoFile: any, TokenKey: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.post<any>(this.myAppUrl + 'api/UserPreferenceFormatting/UpdateUserPreferenceFormatting', anslist, httpOptions)
      .pipe(catchError(this.handleError));
  }
  public uploadFile(fileToUpload: File, userid: any, logoFileName: string, TokenKey: string): Observable<any> {
    const _formData = new FormData();
    _formData.append('file', fileToUpload);
    _formData.append('userid', userid);
    _formData.append('logoFileName', logoFileName);
    return this._http.post<any>(this.myAppUrl + 'api/UserPreferenceFormatting/UploadFile', _formData)
      .pipe(catchError(this.handleError));
  }
  public downloadFile(filename: string, userid: any) {
    const _formData = new FormData();
    _formData.append('filename', filename);
    _formData.append('userid', userid);
    return this._http.post(this.myAppUrl + 'api/UserPreferenceFormatting/DownloadFile', _formData)
      .pipe(catchError(this.handleError));
  }
  handleError(error: Response | any) {
    console.log(error);
    alert(error);
    console.error(error.message || error);
    return Observable.throw(error);
  }
}

